import React from "react";
import PublicPageLayout from "@/components/PublicPageLayout";
import Seo, { pageSchema } from "@/components/Seo";
import { WhatsAppButton } from "@/components/WhatsAppFab";
import { WA_MESSAGES, COVERAGE_FACTS } from "@/lib/site";
import { CheckCircle2 } from "lucide-react";

const STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
  "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
  "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
  "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
  "Uttarakhand", "West Bengal", "Andaman & Nicobar Islands", "Chandigarh",
  "Dadra & Nagar Haveli and Daman & Diu", "Delhi", "Jammu & Kashmir", "Ladakh",
  "Lakshadweep", "Puducherry",
];

export default function DataCoverage() {
  const path = "/data-coverage";
  const title = "Pan India Data Coverage | All 36 States & ROC | Registry Feed";
  const description = "Registry Feed covers all 36 Indian states and union territories. All ROC jurisdictions. Both MCA and GST registrations. Daily updates.";
  const keywords = "mca database maharashtra, gst company list delhi, gst database gujarat, new company list mumbai, roc wise new company list, pan india company database";
  const bc = [{ name: "Home", path: "/" }, { name: "Data Coverage", path }];
  const jsonLd = pageSchema({ title, description, path, breadcrumbs: bc });
  return (
    <PublicPageLayout breadcrumbs={bc}>
      <Seo title={title} description={description} keywords={keywords} path={path} jsonLd={jsonLd} />
      <section className="mx-auto max-w-[1400px] px-4 sm:px-6 py-14 sm:py-20">
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">Data Coverage</h1>
        <p className="mt-4 text-muted-foreground text-base sm:text-lg max-w-3xl">
          Registry Feed is a true pan India company database — every state, every union territory and every ROC jurisdiction, updated daily. From MCA database Maharashtra and new company list Mumbai to GST company list Delhi and GST database Gujarat, filter by state, city, district or ROC to get a ROC wise new company list for exactly the market you sell to.
        </p>

        <div className="mt-8 grid sm:grid-cols-2 gap-3 max-w-3xl">
          {COVERAGE_FACTS.map((c) => (
            <div key={c} className="flex items-start gap-2 rounded-md border border-border bg-card px-3 py-2.5 text-sm">
              <CheckCircle2 className="h-4 w-4 text-primary mt-0.5" /> {c}
            </div>
          ))}
        </div>

        <h2 className="mt-14 font-heading font-bold text-2xl sm:text-3xl tracking-tight">All 36 states &amp; union territories</h2>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 text-sm">
          {STATES.map((s) => (
            <div key={s} className="rounded-md border border-border bg-card px-3 py-2">{s}</div>
          ))}
        </div>

        <div className="mt-10"><WhatsAppButton message={WA_MESSAGES.general} label="Ask about your state" /></div>
      </section>
    </PublicPageLayout>
  );
}
